import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';
import { ErrorBoundary } from './components/error-boundary';
import { UpdateBanner } from './components/update-banner';
import { queryClient } from './lib/api';
import { router } from './router';
import { initTheme } from './lib/theme';
import './index.css';

const PRELOAD_RELOAD_KEY = 'preload-reload-attempted';

window.addEventListener('vite:preloadError', () => {
  if (sessionStorage.getItem(PRELOAD_RELOAD_KEY)) return;
  sessionStorage.setItem(PRELOAD_RELOAD_KEY, '1');
  location.reload();
});

initTheme();

/* Routing runs entirely on TanStack Router (router.tsx). react-router-dom has */
/* been removed; components use the lib/routing compatibility shim. */
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <UpdateBanner />
        <Toaster position="bottom-right" richColors />
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);

try { sessionStorage.removeItem('naia.boot-reloaded'); } catch { }
